module.exports = __webpack_public_path__ + "static/media/TC_MobilePOS.5b9dbc87.pdf";